<template>

  <div class="row">

    <div class="mt-3 col-12" v-if="(isChain || isPecs ||  isPecsWithoutDiscrimination || isPecsWithDiscrimination || isPecsWithItems) && cumulutiveData && cumulutiveData.length">

      <div class="mb-3 pl-1" v-if="isPecs">
        <mdc-radio :label="'report.chart_for_step_daily_pecs' | trans" name="cumulutiveKind"
                   v-model="cumulutiveKind" value="absolute" checked />
        <mdc-radio :label="'report.chart_for_percent_daily_pecs' | trans" name="cumulutiveKind"
                   v-model="cumulutiveKind" value="relative"/>
      </div>
  
      <div class="mb-3 pl-1"  v-if="isPecsWithoutDiscrimination && cumulutiveData">
        <mdc-radio :label="'report.chart_for_step_daily_pecs2' | trans" name="cumulutiveKind"
                   v-model="cumulutiveKind" value="absolute" checked />
        <mdc-radio :label="'report.chart_for_percent_daily_pecs2' | trans" name="cumulutiveKind"
                   v-model="cumulutiveKind" value="relative"/>
      </div>

      <div class="mb-3 pl-1"  v-if="(isPecsWithDiscrimination || isPecsWithItems) && cumulutiveData[0].categoryInfo">
        <mdc-radio :label="'report.number_properties_pecs' | trans" :name="'cumulutiveKind'+cumulutiveData[0].categoryInfo.id"
                   v-model="cumulutiveKind" value="absolute" checked />
        <mdc-radio :label="'report.percent_properties_pecs' | trans" :name="'cumulutiveKind'+cumulutiveData[0].categoryInfo.id"
                   v-model="cumulutiveKind" value="relative"/>
      </div>
  
      <div class="mb-3 pl-1"  v-if="!isPecsWithoutDiscrimination && !isPecs && !isPecsWithDiscrimination && !isPecsWithItems">
        <mdc-radio :label="'report.number_step' | trans" name="cumulutiveKind"
                   v-model="cumulutiveKind" value="absolute" checked />
        <mdc-radio :label="'report.percent_step' | trans" name="cumulutiveKind"
                   v-model="cumulutiveKind" value="relative"/>
      </div>

      <div v-for="(cumulutiveChart,key) in cumulutiveData" v-if="isPecsWithDiscrimination || isPecsWithItems || !selectedStage || (selectedStage && (selectedStage.id == cumulutiveChart.stageInfo.id))">

        <div v-for="(absoluteChart, chartKey) in cumulutiveChart.absoluteData" v-if="(cumulutiveKind === 'absolute' && absoluteChart.values)">
          <line-chart class="row mt-2" :datasets="fetchDatasetForCumulutiveChart(absoluteChart.values)"
                      :chart-id="'cumulutiveChart_'+key+'_absolute_'+chartKey"
                      :stage-info="cumulutiveChart.stageInfo.id"
                      :category-info="cumulutiveChart.categoryInfo"
                      :persentMax="true"
                      :list-chart-date="absoluteChart.xLabels"
                      :y-axes-begin-at-zero="true"
                      :valueMax="absoluteChart.maxY"
                      v-on:popup-show="popupAbsoluteDataShow"
                      :aspect-ratio=false
                      :height="280"
                      :width=null
                      :show-legend="false"
                      :scale-label="(isPecsWithItems || isPecsWithDiscrimination) ? 'report.number_properties_pecs' : isPecs || isPecsWithoutDiscrimination || isPecsWithDiscrimination ? 'report.number_step_pecs' : 'report.number_step' | trans"
                      v-if="absoluteChart.values.length"
          />
          <h4 class="chart__title mb-3" v-if="absoluteChart.values.length && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems">{{isPecs  ? 'report.cumulitive_graph_pecs' : 'protocol.chain_step_chart' | trans}}: {{cumulutiveChart.stageInfo.description}}</h4>
          <h4 class="chart__title mb-3" v-if="absoluteChart.values.length && isPecsWithoutDiscrimination">{{'report.cumulitive_graph_pecs2' | trans}}</h4>
          <h4 class="chart__title mb-3" v-if="absoluteChart.values.length && (isPecsWithItems || isPecsWithDiscrimination)">{{ 'protocol.cumulative_category' | trans }} {{cumulutiveChart.categoryInfo.title}}. <span v-if="isPecsWithDiscrimination">{{stageInfo.description}}</span></h4>
        </div>

        <div  v-if="(cumulutiveKind === 'relative' && cumulutiveChart.relativeData.values.length)" >

          <line-chart class="row mt-2" :datasets="fetchDatasetForCumulutiveChart(cumulutiveChart.relativeData.values)"
                      :chart-id="'cumulutiveChart_relativeData'+key"
                      :stage-info="cumulutiveChart.stageInfo.id"
                      :category-info="cumulutiveChart.categoryInfo"
                      :persentMax="true"
                      :list-chart-date="cumulutiveChart.relativeData.xLabels"
                      :y-axes-begin-at-zero="true"
                      v-on:popup-show="popupRelativeDataShow"
                      :aspect-ratio=false
                      :height="280"
                      :width=null
                      :show-legend="false"
                      :scale-label="(isPecsWithItems || isPecsWithDiscrimination) ? 'report.percent_properties_pecs' : isPecs || isPecsWithoutDiscrimination || isPecsWithDiscrimination ? 'report.percent_step_pecs' : 'report.chart_for_percent_axes' | trans"
                      v-if="(cumulutiveKind === 'relative')"
          />
          <h4 class="chart__title mb-3" v-if="(cumulutiveKind === 'relative') && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems">{{isPecs  ? 'report.cumulitive_graph_pecs' : 'protocol.chain_mastered_chart' | trans}}: {{cumulutiveChart.stageInfo.description}}</h4>
          <h4 class="chart__title mb-3" v-if="(cumulutiveKind === 'relative') && isPecsWithoutDiscrimination">{{'report.cumulitive_graph_pecs2' | trans}}</h4>
          <h4 class="chart__title mb-3" v-if="(cumulutiveKind === 'relative') && (isPecsWithItems || isPecsWithDiscrimination)">{{ 'protocol.cumulative_category_relative'| trans }} {{cumulutiveChart.categoryInfo.title}}. <span v-if="isPecsWithDiscrimination">{{stageInfo.description}}</span></h4>
        </div>

      </div>

      <h5 v-if="cumulutiveData && cumulutiveData[0].relativeData && !cumulutiveData[0].relativeData.values.length" class="text-center">{{'protocol.no_data' | trans }}.</h5>

    </div>


    <div class="mt-5 col-12" v-if="!isChain && !isPecs && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems && cumulutiveData && cumulutiveData.cumulativeData.values.length">

      <line-chart class="row mt-2" :datasets="fetchDatasetForCumulutiveChart(cumulutiveData.cumulativeData.values)"
                  v-if="!selectedStage"
                  chart-id="mandCumulutiveChart"
                  :persentMax="false"
                  :list-chart-date="cumulutiveData.cumulativeData.xLabels"
                  :y-axes-begin-at-zero="true"
                  :aspect-ratio=false
                  :height="260"
                  :width=null
                  :show-legend="false"
                  :scale-label="'report.count_stim' | trans"
      />
      <h4 class="chart__title mb-3" v-if="!selectedStage">{{'report.cumulitive_graph_for_protocol' | trans}}</h4>

      <div v-for="(cumulutiveChart,key) in cumulutiveData.byStageData" v-if="!selectedStage || (selectedStage && selectedStage.id == cumulutiveChart.stageInfo.id)">

        <line-chart class="row mt-2" :datasets="fetchDatasetForCumulutiveChart(cumulutiveChart.values)"
                    :chart-id="'mandCumulutiveChart_'+key"
                    :persentMax="false"
                    :list-chart-date="cumulutiveChart.xLabels"
                    :y-axes-begin-at-zero="true"
                    :aspect-ratio=false
                    :height="260"
                    :width=null
                    :show-legend="false"
                    :scale-label="'report.count_stim' | trans"
        />
        <h4 class="chart__title mb-3">{{'report.cumulitive_graph' | trans}}: {{cumulutiveChart.stageInfo.description}}</h4>

      </div>
    </div>



    <div v-if="isModalVisible">

      <chart-popup :visible="isModalVisible"
                   :isChain="isChain"
                   :isPecs="isPecs"
                   :isPecsWithoutDiscrimination="isPecsWithoutDiscrimination"
                   :isPecsWithDiscrimination="isPecsWithDiscrimination"
                   :isPecsWithItems="isPecsWithItems"
                   v-on:close="onClose"
                   :chartType="type"
                   :version="version"
                   :stage-id="selectedStageId"
                   :graphTitle="isPecsWithItems || isPecsWithDiscrimination ? 'report.chart_properties_per_day' : 'protocol.stimulus_mastering_chart' | trans"
                   :protocolId="protocolId"
                   :categoryInfo="cumulutiveData[0].categoryInfo"
                   :dataPoint="dataPoint">
      </chart-popup>

    </div>



  </div>

</template>

<script>
  import {LineChart, LineChartDataset} from '../../../common/chart';
  import values from 'lodash/values';
  import forEach from 'lodash/forEach';
  import moment from 'moment';
  import {typeProtocol} from '../../../common/mixins/typeProtocol';
  import ChartPopup from '../../dashboardParent/components/ChartPopup';

  export default {
    props: ['teachingMethod', 'cumulutiveData', 'selectedStage', 'protocolId', 'categoryInfo', 'stageInfo'],
    components: {
      LineChart, ChartPopup
    },
    data() {
      return {
        cumulutiveKind: null,
        isModalVisible: false,
        dataPoint: null,
        type: null,
        version: null,
        selectedStageId: null,
      }
    },
    mixins: [typeProtocol],
    methods:{
      fetchDatasetForCumulutiveChart(datasetChart){
        let dataset = new LineChartDataset({
          data: datasetChart
        });
        return [dataset];
      },

      chartDate(chartDateList){
        return values(chartDateList);
      },

      popupAbsoluteDataShow(data,stageId){

        this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
        this.version = data.version;
        this.type = 1;
        this.selectedStageId = stageId;
        this.isModalVisible = true;

      },

      popupRelativeDataShow(data,stageId){

        this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
        this.version = data.version;
        this.type = 2;
        this.selectedStageId = stageId;
        this.isModalVisible = true;

      },


      onClose() {
        this.isModalVisible = false;
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/modules/chart/component/CumulutiveChart.vue